<template>
  <div class="card">
    <div class="card_box" :class="bg">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.card
  height 100%
  position relative

  .card_box
    height 100%
    position relative

  .border-new
    background url('~images/components/border-new.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border1
    background url('~images/components/border1.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border2
    background url('~images/components/border2.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border3
    background url('~images/components/border3.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border4
    background url('~images/components/border4.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border5
    background url('~images/components/border5.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border6
    background url('~images/components/border6.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border7
    background url('~images/components/border7.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border8
    background url('~images/components/border8.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border9
    background url('~images/components/border9.png')
    background-repeat no-repeat
    background-size 100% 100%
  .border10
    background url('~images/components/border10.png')
    background-repeat no-repeat
    background-size 100% 100%
</style>
